import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from 'ngx-bootstrap/tooltip';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

class UserThumbnailService {
    constructor() { }
}
UserThumbnailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: UserThumbnailService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
UserThumbnailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: UserThumbnailService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: UserThumbnailService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class UserThumbnail {
}

const defaultColors = ['#1abc9c', '#3498db', '#f1c40f', '#8e44ad', '#e74c3c', '#d35400', '#2c3e50', '#7f8c8d'];
const defaultForegroundColor = '#FFF';
class UserThumbnailComponent {
    constructor() {
        this.zoom = '0.8em';
        this._size = 32;
        this.useTooltip = true;
    }
    get size() {
        return this._size;
    }
    set size(value) {
        this._size = value;
        this.zoom = (value * 0.025) + 'em';
    }
    get thumbnail() {
        return this._thumbnail;
    }
    set thumbnail(value) {
        this._thumbnail = value;
        if (!value.backgroundColor) {
            this._thumbnail.backgroundColor = this.getRandomColor(this.thumbnail.label);
            this._thumbnail.foregroundColor = defaultForegroundColor;
        }
        this.setReplacementText();
    }
    setReplacementText() {
        if (!this.thumbnail || this.thumbnail.url || !this.thumbnail.label) {
            return;
        }
        this.thumbnail.replacementText = this.thumbnail.label
            .split(' ')
            .map(v => v[0] || '')
            .join('')
            .toUpperCase()
            .substr(0, 2);
    }
    getRandomColor(avatarText) {
        if (!avatarText) {
            return undefined;
        }
        const asciiCodeSum = this.calculateAsciiCode(avatarText);
        return defaultColors[asciiCodeSum % defaultColors.length];
    }
    calculateAsciiCode(value) {
        return value
            .split('')
            .map(letter => letter.charCodeAt(0))
            .reduce((previous, current) => previous + current);
    }
}
UserThumbnailComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: UserThumbnailComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
UserThumbnailComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.8", type: UserThumbnailComponent, selector: "cc-user-thumbnail", inputs: { size: "size", useTooltip: "useTooltip", thumbnail: "thumbnail" }, ngImport: i0, template: "<div class=\"thumbnail overflow-hidden\">\r\n  <div\r\n    [tooltip]=\"useTooltip && thumbnail.label ? thumbnail.label : ''\"\r\n    container=\"body\"\r\n    containerClass=\"text-nowrap\"\r\n    [style.background-image]=\"thumbnail.url ? 'url(' + thumbnail.url + ')' : 'none'\"\r\n    [style.background-color]=\"thumbnail.backgroundColor\"\r\n    [style.background-size]=\"size + 'px ' + size + 'px'\"\r\n    class=\"d-flex align-items-center picture rounded-circle img-thumbnail {{ thumbnail.classes }}\"\r\n    [style.width]=\"size + 'px'\"\r\n    [style.height]=\"size + 'px'\"\r\n  >\r\n    <span *ngIf=\"thumbnail.url\" class=\"visually-hidden\" [style.color]=\"thumbnail.foregroundColor\">{{ thumbnail.label }}</span>\r\n    <div\r\n      *ngIf=\"!thumbnail.url && thumbnail.replacementText\"\r\n      [style.fontSize]=\"zoom\"\r\n      [style.lineHeight]=\"size + 'px'\"\r\n      [style.color]=\"thumbnail.foregroundColor\"\r\n      class=\"text-center w-100 text-uppercase\"\r\n    >\r\n      {{ thumbnail.replacementText }}\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [":host{display:inline-block}:host .picture{max-width:100%;background-repeat:no-repeat;background-position:center;background-size:cover;-webkit-user-select:none;user-select:none}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.TooltipDirective, selector: "[tooltip], [tooltipHtml]", inputs: ["adaptivePosition", "tooltip", "placement", "triggers", "container", "containerClass", "boundariesElement", "isOpen", "isDisabled", "delay", "tooltipHtml", "tooltipPlacement", "tooltipIsOpen", "tooltipEnable", "tooltipAppendToBody", "tooltipAnimation", "tooltipClass", "tooltipContext", "tooltipPopupDelay", "tooltipFadeDuration", "tooltipTrigger"], outputs: ["tooltipChange", "onShown", "onHidden", "tooltipStateChanged"], exportAs: ["bs-tooltip"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: UserThumbnailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cc-user-thumbnail', template: "<div class=\"thumbnail overflow-hidden\">\r\n  <div\r\n    [tooltip]=\"useTooltip && thumbnail.label ? thumbnail.label : ''\"\r\n    container=\"body\"\r\n    containerClass=\"text-nowrap\"\r\n    [style.background-image]=\"thumbnail.url ? 'url(' + thumbnail.url + ')' : 'none'\"\r\n    [style.background-color]=\"thumbnail.backgroundColor\"\r\n    [style.background-size]=\"size + 'px ' + size + 'px'\"\r\n    class=\"d-flex align-items-center picture rounded-circle img-thumbnail {{ thumbnail.classes }}\"\r\n    [style.width]=\"size + 'px'\"\r\n    [style.height]=\"size + 'px'\"\r\n  >\r\n    <span *ngIf=\"thumbnail.url\" class=\"visually-hidden\" [style.color]=\"thumbnail.foregroundColor\">{{ thumbnail.label }}</span>\r\n    <div\r\n      *ngIf=\"!thumbnail.url && thumbnail.replacementText\"\r\n      [style.fontSize]=\"zoom\"\r\n      [style.lineHeight]=\"size + 'px'\"\r\n      [style.color]=\"thumbnail.foregroundColor\"\r\n      class=\"text-center w-100 text-uppercase\"\r\n    >\r\n      {{ thumbnail.replacementText }}\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [":host{display:inline-block}:host .picture{max-width:100%;background-repeat:no-repeat;background-position:center;background-size:cover;-webkit-user-select:none;user-select:none}\n"] }]
        }], propDecorators: { size: [{
                type: Input
            }], useTooltip: [{
                type: Input
            }], thumbnail: [{
                type: Input
            }] } });

class UserThumbnailModule {
}
UserThumbnailModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: UserThumbnailModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
UserThumbnailModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: UserThumbnailModule, declarations: [UserThumbnailComponent], imports: [CommonModule, TooltipModule], exports: [UserThumbnailComponent] });
UserThumbnailModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: UserThumbnailModule, imports: [CommonModule, TooltipModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: UserThumbnailModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UserThumbnailComponent],
                    imports: [CommonModule, TooltipModule],
                    exports: [UserThumbnailComponent]
                }]
        }] });

/*
 * Public API Surface of user-thumbnail
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UserThumbnail, UserThumbnailComponent, UserThumbnailModule, UserThumbnailService, defaultColors, defaultForegroundColor };
